import { MicroviewCommunicationChannel } from '@tableau/microview-communication-service';

export type DataConnection = {
  type: string;
  name: string;
  publishedDatasourceDetailsHasExtracts?: boolean;
  connectionTypeDisplayName?: string;
  hasEmbeddedPassword?: boolean;
  fileName?: string;
  siteUrl?: string;
  serverName: string;
  databaseUsername?: string;
  id?: string;
  dataConnectionsCount: number;
};

export class GetDataConnectionChannel extends MicroviewCommunicationChannel<{ dataSourceIds: string[] }, Promise<DataConnection[]>> {
  public name: string = 'GetDataConnectionChannel';
  public namespace: string = 'SearchMicroview.DataConnection';
}
